import {HttpRequest,HttpMethod} from "./http";

class OrderThaipostSubscribeBatchProvider extends HttpRequest {

    // Start a batch job that subscribes Thaipost tracking for matching orders.
    // Payload shape:
    //   { ids: [int] }       — selected scope
    //   { filter: { ... } }  — filter scope
    start(payload) {
        return this.request(HttpMethod.Post, `/api/v1/orders/thaipost-subscribe-batch`, payload);
    }

    // Poll the status of a running / recent job.
    pollStatus(jobId) {
        return this.request(HttpMethod.Get, `/api/v1/orders/thaipost-subscribe-batch/${jobId}`);
    }
}

export default OrderThaipostSubscribeBatchProvider;
